import { Box, Divider, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import PurchaseTestCard from "../components/TestCard";
import CustomSelectField from "../../../../components/customFields/CustomSelectField";
import { getRealTestTestTypes } from "../../../testPrepDashboard/Api/DashboardApi";
import BlueSmallButton from "../../../../components/customButtons/BlueSmallButton";
import BlueOutlinedSmallButton from "../../../../components/customButtons/BlueOutLinedSmallButton";
import BlueMediumButton from "../../../../components/customButtons/BlueMediumButton";
import BlueLightOutlinedButton from "../../../../components/customButtons/BlueLightOutlineButton";
import { Icon } from "@iconify/react/dist/iconify.js";
import CustomCardWithBorder from "../../../../components/CustomCardWithBorder";
import GlobalCard from "../../../../components/GlobalCardComponent";
import CustomHeading from "../../../../components/customText/CustomHeading";
import { addOneTestItemToCart, GetPurchaseTestData } from "../PurchaseTestApis";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Loader from "../../../../../SAPPages/components/Loader/Loader";
import EmptyCart from "./EmptyCart";
import NoTestAvailableScreen from "./NoTestAvailableScreen";
import { useDispatch, useSelector } from "react-redux";
import { ADD_TEST_TO_CART } from "../../../../../actions";
import AnimatedSnackbar from "../../../../components/snackbars/AnimatedSnackbar";
import { useNavigate } from "react-router-dom";
import { setDefaultTestDataList } from "../../../../../redux/features/testTypecheckout/ProceedWithTestDataReducer";
import DisableBlueSmallButton from "../../../../components/customButtons/DisableSmallBlueButton";

export default function PurchaseTest() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  // const storedData  = JSON?.parse(localStorage.getItem("testDetails")) ;
  const testCartList = useSelector(
    (state) => state?.purchasetestcart?.items || [],
  );
  const defaultTestDetails = (() => {
    try {
      return JSON.parse(localStorage.getItem("testDetails")) || {};
    } catch {
      return {};
    }
  })();

  const [testTypeList, setTestTypeList] = useState([]);
  const [testType, setTestType] = useState(null);
  const [testypeObj, setTestTypeObj] = useState(defaultTestDetails);
  console.log("testCartList", testCartList);

  const [purchaseTestData, setPurchaseTestData] = useState([]);
  const [testDataLoading, setTestDataLoading] = useState(false);
  const [count, setCount] = useState({});
  const [testAmount, setAmount] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // fetch test Type list

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getRealTestTestTypes(userId);
        const Responsedata = data?.data;
        setTestTypeList(Responsedata);
        let selectedTestType = Responsedata?.find(
          (i) => i.sl_no === defaultTestDetails?.sl_no,
        );

        const firstObj = Responsedata?.[0];

        const finalTestType =
          selectedTestType?.sl_no ?? firstObj?.sl_no ?? null;

        const finalObj = selectedTestType ?? firstObj ?? null;
        console.log("finalTestType", finalTestType);
        setTestType(finalTestType);
        setTestTypeObj(finalObj);
      } catch (err) {
        console.error("Could not fetch test types");
        setTestTypeList([]);
      }
    };
    fetchData();
  }, []);

  const handleTestTypeChange = (e) => {
    const selected = e.target.value; // contains the whole object
    setTestType(selected);
    const testTypeobj = testTypeList.find((i) => i.sl_no === selected);
    setTestTypeObj(testTypeobj);
  };

  // get purchase test data

  const handleFetchPurchaseTestData = async () => {
    try {
      setTestDataLoading(true);

      const response = await GetPurchaseTestData({
        test_type_id: testypeObj?.test_type_id,
        sub_test_type_id: testypeObj?.sub_test_type_id,
        user_id: userId,
      });

      if (response.status === 200) {
        setPurchaseTestData(response?.data);
      } else {
        setPurchaseTestData([]);
      }
      setTestDataLoading(false);
    } catch {
      setPurchaseTestData([]);
      setTestDataLoading(false);
    }
  };

  // load first time data
  useEffect(() => {
    handleFetchPurchaseTestData();
  }, [testypeObj]);

  // default amount for each card on 1st render
  useEffect(() => {
    if (purchaseTestData?.length > 0) {
      const initialAmount = {};
      purchaseTestData.forEach((item, index) => {
        initialAmount[index] = item.product_amount * 1; // default count is 1
      });
      setAmount(initialAmount);
    }
  }, [purchaseTestData]);

  // default count for each card on 1st render

  useEffect(() => {
    if (purchaseTestData?.length > 0) {
      const initialCounts = {};
      purchaseTestData.forEach((_, index) => {
        initialCounts[index] = 1;
      });
      setCount(initialCounts);
    }
  }, [purchaseTestData]);

  const handleIncrement = (index) => {
    setCount((prev) => {
      const newCount = prev[index] + 1;

      // update amount also
      setAmount((prevAmt) => ({
        ...prevAmt,
        [index]: purchaseTestData[index].product_amount * newCount,
      }));

      return { ...prev, [index]: newCount };
    });
  };

  const handleDecrement = (index) => {
    setCount((prev) => {
      const newCount = prev[index] > 1 ? prev[index] - 1 : 1;

      // update amount
      setAmount((prevAmt) => ({
        ...prevAmt,
        [index]: purchaseTestData[index].product_amount * newCount,
      }));

      return { ...prev, [index]: newCount };
    });
  };

  // function to check if item is already in cart
  const isItemInCart = (id) => {
    return testCartList?.some((item) => item?.id === id);
  };

  // Add To Cart
  const handleTestAddToCart = async (data, quantity) => {
    try {
      const response = await addOneTestItemToCart({
        //service_id: 1,
        real_test_product_id: data?.id,
        is_adding: true,
        user_id: parseInt(userId),
        quantity: parseInt(quantity),
      });

      if (response.status === 200) {
        dispatch({
          type: ADD_TEST_TO_CART,
          payload: {
            ...data, // full object
            quantity: parseInt(quantity), // add quantity key
          },
        });

        showSnackbar(response.message, "success");
      } else {
      }
    } catch {}
  };

  // buy now function
  const handleBuyNow = (selectedTestData, quantity) => {
    const updatedItem = {
      ...selectedTestData,
      quantity: parseInt(quantity),
      base_price: selectedTestData?.product_amount,
    };
    dispatch(setDefaultTestDataList([updatedItem]));
    navigate("/test-prep/performance/purchase-test/checkout");
  };

  return (
    <>
      <Grid container spacing={2}>
        {/* Header */}
        <Grid item xs={12} sm={6} md={9}>
          <CustomHeading lable="Purchase Test" />
        </Grid>

        <Grid item xs={12} sm={3} md={3} sx={{ textAlign: "right" }}>
          <CustomSelectField
            color="#572575"
            ExpandMoreIconColor="#572575"
            dafualtValue="Select Test Type"
            fontWeight={700}
            borderColor="#E7CEF6"
            borderRadius="8px"
            boxShadow={true}
            options={testTypeList}
            getOptionLabel={(opt) =>
              `${opt?.test_type_name}${
                opt?.sub_test_type_name ? ` ( ${opt.sub_test_type_name} )` : ""
              }`
            }
            getOptionValue={(opt) => opt?.sl_no}
            value={testType}
            onChange={handleTestTypeChange}
          />
        </Grid>

        {testDataLoading ? (
          <Grid item xs={12}>
            <Loader text="Loading Test Details" />
          </Grid>
        ) : !testDataLoading && purchaseTestData?.length > 0 ? (
          <Grid item xs={12}>
            <CustomCardWithBorder boxShadow={true}>
              <Grid container spacing={3}>
                {purchaseTestData?.map((data, index) => (
                  <Grid item xs={12} sm={6} md={4}>
                    <PurchaseTestCard>
                      <Grid container spacing={1.5}>
                        <Grid
                          item
                          xs={12}
                          container
                          alignItems="center"
                          gap={1}
                        >
                          <Box
                            sx={{
                              border: "1px solid rgba(238, 238, 238, 1)",
                              borderRadius: "8px",
                              padding: "6px",
                            }}
                          >
                            <img
                              src={data?.image_path?.image_src}
                              style={{ width: "32px" }}
                            />
                          </Box>
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: 600,
                              color: "#56595D",
                              fontFamily: "Inter",
                            }}
                          >
                            {data?.sub_test_type_id
                              ? data?.sub_test_type_id?.name
                              : data?.test_type_id?.name}{" "}
                            - {data?.product_name}
                          </Typography>
                        </Grid>

                        <Grid item xs={12}>
                          <Divider sx={{ borderColor: "#EEEEEE" }} />
                        </Grid>

                        <Grid item xs={12}>
                          <Typography
                            sx={{
                              fontSize: "18px",
                              fontWeight: 800,
                              color: "#572575",
                            }}
                          >
                            {data?.currency}
                            {""} {testAmount[index]}
                          </Typography>
                        </Grid>

                        <Grid
                          item
                          xs={8}
                          container
                          alignItems="center"
                          justifyContent="flex-start"
                          gap={0.5}
                        >
                          <img
                            src="/PurchaseTest/Vector (7).png"
                            style={{ width: "16px", marginLeft: "-4px" }}
                          />

                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: 400,
                              color: "#333333",
                            }}
                          >
                            Question Quantity :{" "}
                            <span
                              style={{
                                fontSize: "14px",
                                fontWeight: 600,
                                color: "#333333",
                              }}
                            >
                              {data?.question_quantity}
                            </span>
                          </Typography>
                        </Grid>
                        <Grid item xs={4} textAlign="end">
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",

                              justifyContent: "space-between",
                              p: "4px",
                            }}
                          >
                            <IconButton
                              size="small"
                              onClick={() => handleDecrement(index)}
                              sx={{
                                border: "0.5px solid #E9D0F8",
                                color: "#572575",
                                width: "22px",
                                height: "22px",
                                borderRadius: "4px",
                                background: "#ffffff",
                                opacity: count[index] === 1 ? 0.3 : 1,
                              }}
                            >
                              <RemoveIcon fontSize="small" />
                            </IconButton>

                            <Typography
                              sx={{
                                fontWeight: 500,
                                fontSize: "14px",
                                width: "30px",
                                textAlign: "center",
                                fontFamily: "Inter",
                                color: "#000000",
                              }}
                            >
                              {count[index]?.toString().padStart(2, "0")}
                            </Typography>

                            <IconButton
                              size="small"
                              onClick={() => handleIncrement(index)}
                              sx={{
                                border: "0.5px solid #E9D0F8",
                                color: "#572575",
                                width: "22px",
                                height: "22px",
                                borderRadius: "4px",
                                background: "#ffffff",
                              }}
                            >
                              <AddIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          container
                          gap={2}
                          justifyContent="center"
                        >
                          {isItemInCart(data?.id) ? (
                            <BlueLightOutlinedButton
                              buttonTitle="Go To Cart"
                              minWidth="46%"
                              onClick={() =>
                                navigate("/test-prep/my-exam-cart")
                              } // <-- use your cart route
                            />
                          ) : (
                            <BlueLightOutlinedButton
                              buttonTitle="Add To Cart"
                              minWidth="46%"
                              onClick={() =>
                                handleTestAddToCart(
                                  data,
                                  count[index]?.toString().padStart(2, "0"),
                                )
                              }
                            />
                          )}
                          {!data?.rt_enrolled && (
                            <BlueMediumButton
                              buttonTitle="Buy Now"
                              minWidth="46%"
                              endIcon={
                                <Icon icon="icon-park-outline:buy" width={16} />
                              }
                              onClick={() =>
                                handleBuyNow(
                                  data,
                                  count[index]?.toString().padStart(2, "0"),
                                )
                              }
                            />
                          )}
                          {data?.rt_enrolled && (
                            <DisableBlueSmallButton
                              buttonTitle="Buy Now"
                              minWidth="46%"
                              height={30}
                              endIcon={
                                <Icon icon="icon-park-outline:buy" width={16} />
                              }
                            />
                          )}
                        </Grid>
                      </Grid>
                    </PurchaseTestCard>
                  </Grid>
                ))}
              </Grid>
            </CustomCardWithBorder>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <NoTestAvailableScreen
              topImage={<img src="/PurchaseTest/Group 1171283373 (3).png" />}
              topimageWidth="88px"
              text="No Data Available!"
              subText="It looks like there’s no data for this test type at the moment. Please select a different test type or check back later."
              buttonName="Purchase Test"
              maxWidth="100%"
              startIcon={<Icon icon="material-symbols:crown-rounded" />}
            />
          </Grid>
        )}
      </Grid>

      <AnimatedSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
